<template>
    <v-select class="form-control"
              
            v-model="selectedJourney"
            :placeholder="resource('JourneyBuilder_JourneyDropdown_PlaceholderText')"

            label="name"
            :options="journeys"

            clearable
            searchable
            filterable
    >
        
    </v-select>
</template>

<script>
    import api from '../api';
    import {bootstrapDangerGrowl as errorGrowl} from "../../../Util/growler";
    
    import resourceMixin from "../../../Util/Mixins/resources";
    
    import VSelect from 'vue-select';

    export default {
        components: {
            VSelect
        },
        mixins: [resourceMixin],
        created() {
            const vm = this;
            
            api.listJourneys().then(
                journeys => vm.journeys = journeys,
                err => errorGrowl(err)
            );
        },
        computed: {
            selectedJourney: {
                get(){
                    const {value: journeyId} = this;
                    
                    if(!journeyId){
                        return null;
                    }
                    
                    return this.journeys.find(({id}) => id === journeyId);
                },
                set(value){
                    this.$emit('input', value ? value.id : null);
                }
            }
        },
        data: () => ({
            journeys: []
        }),
        props: {
            value: {
                type: String,
                required: false
            }
        }
    }
</script>